import { posAxiosClient } from '@kinderlabs-pos/apis/axios';
import { ProductInfoType } from '@kinderlabs-pos/shared-data-type';

export const setSoldOutSetOptionAsync =
	(rootUrl: string) =>
	async ({ productId, optionId, soldOut }: SetSoldOutSetOptionRequestType) =>
		(
			await posAxiosClient.post<ProductInfoType>(
				`${rootUrl}/product/${productId}/set-option/${optionId}/sold-out`,
				undefined,
				{
					params: { soldOut },
				}
			)
		).data;

export type SetSoldOutSetOptionRequestType = {
	productId: number;
	optionId: number;
	soldOut: boolean;
};
